export default __webpack_public_path__ + "static/media/cl.dba3c80c.svg";